import { Chip } from "@mui/material";

const statusColors: Record<
  string,
  { bg: string; text: string; label: string }
> = {
  0: {
    bg: "hsl(45, 90%, 50%)",
    text: "hsl(45, 90%, 20%)",
    label: "Επερχόμενη",
  },
  1: { bg: "hsl(150, 60%, 25%)", text: "white", label: "Ενεργή" },
  2: { bg: "hsla(199, 49%, 43%, 1.00)", text: "white", label: "Ολοκληρωμένη" },
  3: { bg: "hsla(333, 70%, 29%, 1.00)", text: "white", label: "Ακυρωμένη" },
};

export const StatusChip = ({ status }: { status: string }) => {
  return (
    <Chip
      label={statusColors[status].label}
      size="small"
      sx={{
        bgcolor: statusColors[status].bg,
        color: statusColors[status].text,
        fontWeight: 600,
        textTransform: "capitalize",
      }}
    />
  );
};
